import React, {useState} from "react";
import {Grid, Stack, TextField} from "@mui/material";
import Button from "@mui/material/Button";
import SaveRoundedIcon from "@mui/icons-material/SaveRounded";
import DinoDialog from "../../../../components/Dialog";
import {AddCircleRounded, EditRounded} from "@mui/icons-material";
import RecurrenceSelector from "../../../../components/RecurrenceSelector";
import DeleteRoundedIcon from "@mui/icons-material/DeleteRounded";
import Occurrence from "./Occurrence";
import { isValid, format } from "date-fns";
import {TimePicker} from "@mui/x-date-pickers/TimePicker";
import useServiceRecurrence from "../../../../hooks/queries/useServiceRecurrence";
import ServiceRecurrenceCard from "../../../../components/ServiceRecurrenceCard";
import {useSnackbar} from "notistack";

const Recurring = ({reference, data, setData}) => {
    const [current, setCurrent] = useState({});
    const [startDate, setStartDate] = useState(null);
    const [serviceRecurrence, setServiceRecurrence] = useState({});
    const [popupOpen, setPopupOpen] = useState(false);
    const [editPopupOpen, setEditPopupOpen] = useState(false);
    const [deletePopupOpen, setDeletePopupOpen] = useState(false);
    const {useServiceRecurrenceServiceQuery, createServiceRecurrenceMutation, updateServiceRecurrenceMutation, deleteServiceRecurrenceMutation} = useServiceRecurrence()
    const {data: serviceRecurrences, isPending: serviceRecurrencesLoading} = useServiceRecurrenceServiceQuery(data.id)
    const {enqueueSnackbar} = useSnackbar()

    const handleDateChange = (newValue) => {
        if (!newValue || !isValid(newValue)) {
            setServiceRecurrence({
                ...serviceRecurrence,
                start: null
            });
            return;
        }
        setStartDate(newValue);
        setServiceRecurrence({
            ...serviceRecurrence,
            start: format(newValue, "HH:mm")
        });
    };

    return <div>

        <Occurrence data={data} reference={reference} setData={setData} />

        {data?.occurrence === 'recurring' && (
            <Stack marginTop={2}>
                {/* Grid of cards */}
                <Grid container spacing={2}>
                    {serviceRecurrences?.map(s => (
                        <Grid item xs={12} lg={6} key={s.id}>
                            <ServiceRecurrenceCard
                                recurrence={s}
                                onDelete={() => {
                                    setDeletePopupOpen(true)
                                    setCurrent(s)
                                }}
                                onEdit={() => {
                                    setEditPopupOpen(true)
                                    setCurrent(s)
                                }}
                            />
                        </Grid>
                    ))}
                </Grid>

                {/* Button below the grid */}
                <Stack direction="row" justifyContent="end" marginTop={2}>
                    <Button
                        size="large"
                        variant="contained"
                        endIcon={<SaveRoundedIcon />}
                        onClick={() => setPopupOpen(true)}
                    >
                        Új ismétlődés hozzáadása
                    </Button>
                </Stack>
            </Stack>
        )}



        <DinoDialog
            open={popupOpen}
            title='Új ismétlődés'
            subtitle=''
            handleClose={() => setPopupOpen(false)}
            actions={<Stack direction='row' spacing={1}>
                <Button
                    variant='outlined'
                    onClick={() => setPopupOpen(false)}>
                    Mégsem
                </Button>
                <Button
                    variant='contained'
                    onClick={() => {
                        createServiceRecurrenceMutation.mutate({...serviceRecurrence, service: data.id}, {
                            onError: errors => {
                                errors.errors.forEach(err => {
                                    if (err.field) {
                                        // field-specific error logic
                                        enqueueSnackbar(`${err.message} - ${err.field}`, {variant: 'error'});
                                    } else {
                                        // general notification
                                        enqueueSnackbar(err.message, {variant: 'error'});
                                    }
                                });
                            },
                            onSuccess: response => {
                                setPopupOpen(false)
                            }
                        })

                    }} endIcon={<AddCircleRounded/>}>
                    Hozzáadás
                </Button>
            </Stack>}>
            <div>
                <RecurrenceSelector onChange={data => setServiceRecurrence(p => ({...p, recurrence: data}))}/>
                <Stack direction='row' spacing={2} sx={{mt: 2}}>
                    <TimePicker
                        ampm={false}
                        value={startDate}
                        onChange={handleDateChange}
                        minutesStep={5}
                        renderInput={(params) => <TextField variant='standard' {...params} />}
                    />
                </Stack>
            </div>
        </DinoDialog>

        <DinoDialog
            open={editPopupOpen}
            title='ismétlődés szerkesztése'
            subtitle=''
            handleClose={() => setEditPopupOpen(false)}
            actions={<Stack direction='row' spacing={1}>
                <Button
                    variant='outlined'
                    onClick={() => setEditPopupOpen(false)}>
                    Mégsem
                </Button>
                <Button
                    variant='contained'
                    onClick={() => {
                        updateServiceRecurrenceMutation.mutate({id: current.id, data: serviceRecurrence})
                        setEditPopupOpen(false)
                    }} endIcon={<EditRounded/>}>
                    Szerkesztés
                </Button>
            </Stack>}>
            <div>
                <RecurrenceSelector data={current?.recurrence?.data} onChange={data => setServiceRecurrence(p => ({...p, recurrence: data}))}/>
                <Stack direction='row' spacing={2} sx={{mt: 2}}>
                    <TimePicker
                        ampm={false}
                        value={startDate}
                        onChange={handleDateChange}
                        minutesStep={5}
                        renderInput={(params) => <TextField variant='standard' {...params} />}
                    />
                </Stack>
            </div>
        </DinoDialog>


        <DinoDialog
            open={deletePopupOpen}
            title='ismétlődés törlése'
            subtitle='Biztosan kitörlöd ezt a ismétlődést? Az ide leadott foglalások nem fognak tölődni!'
            handleClose={() => setDeletePopupOpen(false)}
            actions={<Stack direction='row' spacing={1}>
                <Button
                    variant='outlined'
                    onClick={() => setDeletePopupOpen(false)}>
                    Mégsem
                </Button>
                <Button
                    variant='contained'
                    onClick={() => {
                        deleteServiceRecurrenceMutation.mutate(current.id)
                        setDeletePopupOpen(false)
                    }} endIcon={<DeleteRoundedIcon/>}>
                    Törlés
                </Button>
            </Stack>}
        />
    </div>
}

export default Recurring